module.exports = __webpack_public_path__ + "img/personal-details.72623c50.svg";